import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface Device {
    delete_timestamp: string | null;
    name: string;
    data: DeviceRakindaData | DeviceZhilaiData | DeviceTerminalData | DeviceS4MModbusData | null;
    type: DeviceType;
    brand: DeviceBrand;
    protocol: DeviceProtocol;
    status: string | null;
    heartbeat_timestamp: string | null;
    version: string | null;
    update_timestamp: string;
    actuator_service_name: string | null;
    id: string;
    account_id: string;
    iot_id: string;
    creation_timestamp: string;
    description: string | null;
}

export type DeviceListResponse = PaginatedResponse<Device>;

export interface CreateDevice {
    name?: string;
    data?: DeviceRakindaData | DeviceZhilaiData | DeviceTerminalData | DeviceS4MModbusData | null;
    type?: DeviceType;
    brand?: DeviceBrand;
    protocol?: DeviceProtocol;
    status?: string | null;
    actuator_service_name?: string | null;
    description?: string | null;
}

export interface UpdateDevice {
    name?: string | null;
    data?: DeviceRakindaData | DeviceZhilaiData | DeviceTerminalData | DeviceS4MModbusData | null;
    type?: DeviceType | null;
    brand?: DeviceBrand | null;
    protocol?: DeviceProtocol | null;
    status?: string | null;
    actuator_service_name?: string | null;
    description?: string | null;
}

export interface DeviceZhilaiData {
    board: string;
    slot: string;
    ip_address: string;
}

export interface DeviceTerminalData {
    user_interface_id: string | null;
}

export interface DeviceRakindaData {
    master_pin_code: string | null;
}

export interface DeviceS4MModbusData {
    ip_address: string;
    door_index: number;
    open_command: number;
    rotate_column: number | null;
    max_open_command: number | null;
    max_rotate_column: number | null;
}

export interface DeviceSerialPortData {
    url: string;
    baudrate: number;
}

export interface DeviceS4MSerialData extends DeviceSerialPortData {
    board: string;
    address: string;
}

export enum QueryParams {
    TYPE = 'type',
    IOT_ID = 'iot_id',
    PROTOCOL = 'protocol'
}

export type DeviceQueryParams = DefaultQueryParams | QueryParams;

export enum DeviceType {
    BADGE_READER = 'badge_reader',
    CABINET = 'cabinet',
    CAMERA = 'camera',
    CAROUSEL = 'carousel',
    DOOR = 'door',
    FAN = 'fan',
    KEYBOARD = 'keyboard',
    KEYPAD = 'keypad',
    LIGHTS = 'lights',
    LOCKER = 'locker',
    POWER_BOARD = 'power_board',
    QR_READER = 'qr_reader',
    SCREEN = 'screen',
    SYNC = 'sync',
    SYSTEM = 'system',
    TAG_READER = 'tag_reader',
    TERMINAL = 'terminal'
}

export enum DeviceBrand {
    ACS = 'acs',
    ARSELOR_MITTAL = 'arcelor_mittal',
    CROWN = 'crown',
    DATALOGIC = 'datalogic',
    FACH = 'fach',
    GENERIC = 'generic',
    GIS = 'gis',
    HONEYWELL = 'honeywell',
    KERONG = 'kerong',
    RAKINDA = 'rakinda',
    S4M = 's4m',
    TELLOPORT = 'telloport',
    UNIPAS = 'unipas',
    ZHILAI = 'zhilai'
}

export enum DeviceProtocol {
    EMBEDDED = 'embedded',
    MODBUS = 'modbus',
    SERIAL = 'serial',
    TCP = 'tcp',
    USB = 'usb'
}

export interface DeviceSensorErrorData {
    code: string;
    body: string;
    solution: string;
    blocking: boolean;
    require_service: boolean;
}

export interface DeviceSensorDebugData {
    healthy: boolean;
    status: string;
    info: string;
}

export interface DeviceDataTemplate {
    [key: string]: {
        [key: string]: {
            key: string;
            required: boolean;
            type: string;
            options?: string[] | number[];
            default?: string | number;
            info?: string;
        }[];
    };
}
